import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output, signal, TemplateRef } from '@angular/core';
import { SimButtonModule } from '@simOn/ui/sim-button';
import { SimSelectModule } from '@simOn/ui/sim-select';
import { SimEditPanelComponent } from '../edit-panel/edit-panel.component';
import { closePanelOnEscape } from '../sidenav-right-portal/close-panel-on-escape';

export interface SpaceSelectOption {
  id: string;
  name: string;
}

@Component({
  selector: 'sim-space-select',
  imports: [NgTemplateOutlet, SimButtonModule, SimSelectModule, SimEditPanelComponent],
  templateUrl: './space-select.component.html',
  styleUrl: './space-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpaceSelectComponent {
  private readonly _clickEscapeEffect = closePanelOnEscape(() => this.closePanel.emit());

  protected readonly selectedSpaceId = signal<string>('');

  readonly spaces = input.required<SpaceSelectOption[]>();
  readonly title = input<string>('');
  readonly descriptionTemplate = input<TemplateRef<unknown> | null>(null);
  readonly icon = input<string>('asset');
  readonly addLabel = input<string>('');

  readonly spaceConfirmed = output<string>();
  readonly closePanel = output<void>();

  protected readonly spaceSearchText = (space: SpaceSelectOption): string => space.name;

  protected onSpaceChange(value: string): void {
    this.selectedSpaceId.set(value);
  }

  protected confirm(): void {
    const id = this.selectedSpaceId();
    if (id) {
      this.spaceConfirmed.emit(id);
    }
  }

  protected cancel(): void {
    this.closePanel.emit();
  }

  protected close(): void {
    this.closePanel.emit();
  }
}
